<template>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Platfox Configuration</h4>
    </div>
    <div class="card-body">
      <alert-box type="danger" v-if="store.status !== 'active'">
        <div class='text-center'>
          Please connect this store to a platfox account to finish initializing
        </div>
      </alert-box>
      <loading-container :loading="loading" v-else>
        <input-select
          label="Platfox Website"
          name="websiteId"
          placeholder="Select a platfox website to connect"
          class="m-0"
          :options="websiteOptions"
          :value="form.websiteId"
          @input="value => setField({ key: 'websiteId', value})"
        />

        <div class="mt-3 text-right">
          <form-button
            type="primary"
            input-type="button"
            :disabled="formLoading"
            :loading="formLoading"
            text="SAVE"
            :click="() => updateWebsite()"
          />
        </div>
      </loading-container>
    </div>
  </div>
</template>


<script>
  import { mapGetters, mapActions } from "vuex";
  import _ from 'lodash'

  import LoadingContainer from "@/components/Misc/LoadingContainer";
  import InputSelect from "@/components/Form/InputSelect";
  import FormButton from "@/components/Form/FormButton";
  import AlertBox from '@/components/Misc/AlertBox';

  export default {
    name: "PlatfoxConfiguration",
    props: ["store"],
    components: {
      LoadingContainer,
      InputSelect,
      FormButton,
      AlertBox,
    },
    beforeMount() {
      if (this.store.status == 'active') {
        this.getWebsites(this.store.id);
      }
      
      this.clearForm();
      this.setField({ key: 'websiteId', value: this.store.configuration.websiteId });
    },
    computed: {
      ...mapGetters({
        formLoading: "store/formLoading",
        websites: 'store/platfoxWebsites',
        form: "store/form",
        error: 'store/error',
      }),
      websiteOptions() {
        return this.websites 
          ? this.websites.map(item => ({
            value: item.website_code,
            text: item.domain,
          })) 
          : [];
      },
      loading() {
        return _.isEmpty(this.websites)
      },
    },
    methods: {
      ...mapActions({
        setField: "store/setField",
        clearForm: "store/clearForm",
        getWebsites: "store/getPlatfoxWebsites",
        updateWebsite: "store/updatePlatfoxWebsite",
      }),
    }
  };
</script>
